import { useIntercom } from "react-use-intercom";

import PrimaryButton from "../../../Components/Buttons/primary-button";

import { useModalContext } from "../../../Contexts/ModalContext";

import { modalVariants } from "../../../Utils/constants";

export default function renderStakeCheckingClosedAlert(modalContext) {
  const { updateModalComponent, setPreventCloseOnBackdropClick, setModalVariant, setModalTitle, setModalClassName } =
    modalContext;

  updateModalComponent(StakeCheckingClosedAlert);
  setModalVariant(modalVariants.flexDialog);
  setPreventCloseOnBackdropClick(true);
  setModalClassName("no-full-screen align-title-left");
  setModalTitle("⚠️ Stake Checking Account Closed Due to Unpaid Membership Fees");
}

const StakeCheckingClosedAlert = () => {
  const { show: showIntercom } = useIntercom();

  const { onModalClose } = useModalContext();

  const openSupport = () => {
    showIntercom();
    onModalClose();
  };

  return (
    <>
      <div className="modal-dialog-content">
        <p className="text-base-regular color--mist mb-3">
          Your Stake Checking account has been closed after two unsuccessful attempts to collect the{" "}
          <span className="text-base-medium">$10 Stake Saver Membership</span> Fee.
        </p>
        <p className="text-base-regular color--mist mb-3">
          This happened because the activity requirements to waive the fee were not met.
        </p>
        <p className="text-base-regular color--mist mb-3">
          You’ll still have full access to your Stake Wallet and rewards—but Stake Checking is no longer active.
        </p>
        <p className="text-base-regular color--mist mb-3">
          <span className="text-base-medium">Good News:</span> You can reapply for Stake Checking after a 3-month
          waiting period if you'd like to open a new account.
        </p>
        <p className="text-base-regular color--mist mb-3">To avoid this in the future:</p>
        <ul className="ps-4 mb-3">
          <li className="text-base-medium color--mist mb-2">Maintain an average balance of $250+, OR</li>
          <li className="text-base-medium color--mist">Pay rent using your Stake Checking account</li>
        </ul>
        <p className="text-base-regular color--mist mb-0">
          Need help or have questions? Feel free to contact our support team.
        </p>
      </div>
      <div className="action-container split-equally">
        <PrimaryButton onClick={openSupport}>Contact Support</PrimaryButton>
        <PrimaryButton className="secondary-colors" onClick={onModalClose}>
          Close
        </PrimaryButton>
      </div>
    </>
  );
};
